module.exports = __webpack_public_path__ + "static/index/img/baikal-206.1efa6de8.jpg";